module.exports = __webpack_public_path__ + "img/thanhlong3.6e5533a2.jpg";